import React from 'react'
import {
  Badge,
  Text,
  Button,
  Paragraph,
  Textarea,
  toaster,
  Popover,
  Dialog,
  Checkbox,
  Strong,
  TextInput,
  TextInputField,
  Pane
} from 'evergreen-ui'

const index = ({ onNoShow, bookingId }) => {
  return (
    <Pane
      display={'flex'}
      flexDirection={'row'}
      border
      height={40}
      marginTop={10}
      padding={15}
      borderRadius={5}
      marginBottom={10}
      alignItems='center'
      justifyContent='space-between'
    >
      {' '}
      <Strong color={'#696f8c'}>Mark As No Show</Strong>{' '}
      <Checkbox
        marginRight={15}
        checked={false}
        onChange={() => {
          onNoShow(bookingId)
        }}
      />
    </Pane>
  )
}

export default index
